import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
import Login from './pages/auth/Login';
import * as Sentry from "@sentry/react";
import PrivateRoute from './PrivateRoute';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import 'antd/dist/antd.css';
import './index.css';

Sentry.init({
	dsn: "https://c55251b173ae15d1847472cd91d6f9ca@sentry.velox.am/4",
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
	],
	tracesSampleRate: 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});

ReactDOM.render(
	<React.Fragment>
		<Router>
			<Switch>
				<Route path={"/login"} component={Login}/>
				<PrivateRoute path={"/"} component={App}/>
			</Switch>
		</Router>
	</React.Fragment>,
	document.getElementById('root')
);

